export default "__VITE_ASSET__CIeAbMSQ__"